import React from "react";
import { useNavigate } from "react-router-dom";
import { BsXOctagon } from "react-icons/bs";
import "./AccessDeniedComponent.css";
import brandAsureLogo from "../assets/brand_assure_logo.svg"; // 🟩 Include logo

const AccessDeniedComponent = () => {
  const navigate = useNavigate();

  // 🔹 Logout handler (same logic as in Header)
  const handleLogout = async () => {
    try {
      const response = await fetch("/mcv/logout", {
        method: "GET",
        credentials: "include",
      });
      // console.log("I'm in handleLogout of AccessDeniedComponent");

      if (response.ok) {
        // Clear all stored session/localStorage items
        localStorage.removeItem("userId");
        localStorage.removeItem("userData");
        localStorage.removeItem("userDbDefault");
        localStorage.removeItem("activeButton");
        localStorage.removeItem("isValidateOpen");
        localStorage.removeItem("isManageOpen");
        localStorage.removeItem("logoutExpiration");

        // Redirect to login
        navigate("/mcv/login");
      } else {
        // console.error("Logout failed:", response);
        navigate("/mcv/login"); // still redirect
      }
    } catch (error) {
      // console.error("Error logging out:", error);
      navigate("/mcv/login");
    }
  };

  return (
    <div className="access-container">
      <div className="access-page-header">
        <img src={brandAsureLogo} alt="BrandAssure" className="access-page-logo" />
      </div>

      <div className="access-content">
        <div className="access-header">
          <BsXOctagon className="access-icon" />
          <div className="access-title">Access Denied</div>
        </div>

        <p className="access-description">
          You have not been invited to join. Please contact your administrator for access.
        </p>

        {/* <button className="access-button" onClick={() => navigate("/mcv/login")}>
          Go to Login
        </button> */}

        <button className="access-button" onClick={handleLogout}>
          Go to Login
        </button>
      </div>
    </div>
  );
};

export default AccessDeniedComponent;